<template>
    <v-container class="pa-2 ma-2">
        <v-card color="#FFD375" flat :width="width">
            <v-row>
                <v-col cols="3">
                    <v-list-item-title class="boldtext">Alerts</v-list-item-title>
                </v-col>
                <v-col cols="9">
                    <v-radio-group v-model="emailRadioGroup" @change="changeHandler(1)">
                        <v-radio label="No alert notifications" value="0"></v-radio>
                        <v-radio label="Email me instantly with red alerts only" value="1"></v-radio>
                        <v-radio label="Email me instantly with red alerts and once a day with other alerts" value="2"></v-radio>
                        <v-radio label="Email me once a day with new alerts" value="3"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="3">
                    <v-list-item-title class="boldtext">Surveys</v-list-item-title>
                </v-col>
                <v-col cols="9">
                    <v-radio-group v-model="surveyRadioGroup" @change="changeHandler(2)">
                        <v-radio label="No survey notifications" value="0"></v-radio>
                        <v-radio label="Email me instantly with new surveys" value="1"></v-radio>
                        <v-radio label="Email me once a day with new surveys" value="2"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>


<script>

    import firebase from 'firebase';

    export default {
        mounted: function () {
            this.emailRadioGroup = this.$store.state.currentuser.AlertEmail;
            this.surveyRadioGroup = this.$store.state.currentuser.SurveyEmail;
        },
        data: () => ({
            emailRadioGroup: "",
            surveyRadioGroup: "",
            width:"400px",
        }),
        components: {
        },
        methods: {
            changeHandler(v) {
                if (v == 1) {
                    firebase.database().ref('usercore/' + this.$store.state.user.uid + '/AlertEmail').set(this.emailRadioGroup);
                };
                if (v == 2) {
                    firebase.database().ref('usercore/' + this.$store.state.user.uid + '/SurveyEmail').set(this.surveyRadioGroup);
                }
            }
        },
        computed: {
        }
    }
</script>

<style scoped>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFA500;
        }

        .tile:active {
            background: #FFD375;
        }

    .registeredtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #86F499;
    }

        .registeredtile:hover {
            background: #FFA500;
        }

        .registeredtile:active {
            background: #FFD375;
        }

    .unregisteredtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #F49C86;
    }

        .unregisteredtile:hover {
            background: #FFA500;
        }

        .unregisteredtile:active {
            background: #FFD375;
        }
    .selectedtile {
        margin: 0px;
        padding: 10px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .bckgrnd {
        background: #FFD375;
    }

    .boldtext{
        color:black;
        font-size:large;
        font-weight:bold;
    }

    .smalltext{
        color:darkslategray;
        font-size:small;
        margin-top:4px;
    }
</style>

